import {ProductFamilyIcons} from "App/services/api";
import {FetchAction, FetchState} from "App/services";
import {ActionType} from "App/constants";

export interface State {
    catId: number
    subcategory: ProductFamilyIcons
}

export function reducer(state: State | null = null, action: FetchAction) {
    switch (action.type) {
        case ActionType.FETCH_PRODUCTFAMILYICONS: {
            switch (action.state) {
                case FetchState.SUCCESS: {
                    return {
                        catId: <number>action.params,
                        subcategory: action.payload
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.PAGE_MAIN: {
            return null;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/subcategories.ts